import { Button, Flow, Icon, Theme, useTheme } from 'bold-ui'
import { TipoEnderecoEnum } from 'graphql/types.generated'
import { Fragment, useState } from 'react'
import { isObjectDeepEmpty } from 'util/object'
import { convertToInitialValuesMicroareasFilter } from 'view/visualizacaoTerritorial/converter'

import {
  TerritorioViewTabEnum,
  VisualizacaoMicroareasFilterFormModel,
  VisualizacaoMicroareasFilterModel,
} from '../../model'
import { MicroareasFilterModal } from './MicroareasFilterModal'
import { MicroareasFilterTags } from './MicroareasFilterTags'

interface MicroareasFilterProps {
  tipoEndereco: TipoEnderecoEnum
  microareasFilter?: VisualizacaoMicroareasFilterModel
  onSubmit(values: VisualizacaoMicroareasFilterFormModel): void
}

export function MicroareasFilter(props: MicroareasFilterProps) {
  const { onSubmit, microareasFilter, tipoEndereco } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const [isFiltrosAvancadosOpen, setIsFiltrosAvancadosOpen] = useState(false)

  return (
    <Fragment>
      <Flow direction='horizontal' alignItems='center' justifyContent='space-between'>
        <MicroareasFilterTags filter={microareasFilter} />
        <Button size='small' kind='primary' onClick={() => setIsFiltrosAvancadosOpen(true)}>
          <Flow direction='horizontal' gap={0.5}>
            <Icon icon='filterOutline' />
            Filtros
          </Flow>
        </Button>
      </Flow>

      {!isObjectDeepEmpty(microareasFilter ?? {}) && <div style={styles.divider} />}

      {isFiltrosAvancadosOpen && (
        <MicroareasFilterModal
          tabContext={TerritorioViewTabEnum.LISTA_DE_IMOVEIS}
          open={isFiltrosAvancadosOpen}
          onModalClose={() => setIsFiltrosAvancadosOpen(false)}
          onSubmit={onSubmit}
          tipoEndereco={tipoEndereco}
          initialValues={convertToInitialValuesMicroareasFilter(microareasFilter)}
        />
      )}
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  divider: {
    borderBottom: `1px solid ${theme.pallete.divider}`,
    margin: '.5rem 0',
  },
})
